<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("cookie.menu.cookie_groups") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <div class="space-y-3">
                    <TypeCard
                        v-for="item in consentTypes"
                        :key="item"
                        :item="item"
                        @click="$emit('edit', item)"
                        @edit="$emit('edit', item)"
                    />
                </div>
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import TypeCard from "./TypeCard.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        TypeCard,
        PageSidebar,
        cSaveButton,
    },
    emits: ["edit"],
    computed: {
        ...mapState("cookie", ["cookie", "hasChanges", "consentTypes"]),
    },
    methods: {
        ...mapActions("cookie", ["saveSnapshot"]),
    },
};
</script>
